import { useState } from "react";
import { useOne } from "@refinedev/core";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { FormHeader } from "@/components/forms";
import { Plus } from "lucide-react";
import { type Course, getCourseTitle } from './types';
import { ModulesInlineEditor } from "../modules";

/**
 * CoursesModules
 *
 * Компонент modules для модуля courses
 *
 * @returns {React.ReactElement} React компонент
 */
export function CoursesModules() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [addModuleOpen, setAddModuleOpen] = useState(false);

  const { result: course, query } = useOne<Course>({
    resource: "courses",
    id: id ?? "",
    meta: {
      include: ["translations", "modules"],
    },
  });

  if (query.isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  if (!course) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">Курс не найден</p>
        <Button variant="link" onClick={() => navigate("/courses")}>
          Вернуться к списку
        </Button>
      </div>
    );
  }

  const title = getCourseTitle(course);

  return (
    <div className="space-y-6">
      <FormHeader
        title="Модули курса"
        description={title}
        onBack={() => navigate(-1)}
        sticky
        actions={
          <Button onClick={() => setAddModuleOpen(true)}>
            <Plus className="h-4 w-4 mr-2" />
            Добавить модуль
          </Button>
        }
      />

      <ModulesInlineEditor
        courseId={course.id}
        modules={course.modules ?? []}
        onRefresh={() => query.refetch()}
        addModuleOpen={addModuleOpen}
        onAddModuleOpenChange={setAddModuleOpen}
      />
    </div>
  );
}
